import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  clear(): void {
    sessionStorage.clear();
  }

  public save<T>(model: T, key: string): void {
    sessionStorage.removeItem(key);
    sessionStorage.setItem(key, JSON.stringify(model));
  }

  public delete(key: string) {
    sessionStorage.removeItem(key);
  }

  public get<T>(key: string): any {
    const model = sessionStorage.getItem(key);
    if (model) {
      return JSON.parse(model) as T;
    }

    return undefined;
  }

  public includes(key: string): boolean {
    const model = sessionStorage.getItem(key);
    if (model) {
      return true;
    }

    return false;
  }
}
